"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationKeyForCarline = exports.getVehicleKeyForCarline = exports.getTranslationKeyForVehicleType = exports.getVehicleKeyForConfigurationDetails = exports.getVehicleKeyForVehicleType = void 0;
const transform_types_1 = require("../types/transform.types");
const vehicleType_1 = require("./vehicleType");
const getVehicleKeyForVehicleType = (vehicleType) => {
    switch (vehicleType) {
        case transform_types_1.VehicleTypeEnum.ICE:
            return "gas";
        case transform_types_1.VehicleTypeEnum.PEV:
            return "electro";
        case transform_types_1.VehicleTypeEnum.OVCHEV:
            return "hybrid";
        case transform_types_1.VehicleTypeEnum.NOVCHEV:
            return "normal";
        case transform_types_1.VehicleTypeEnum.NOVCFCHV:
            return "normal";
        default:
            return "normal";
    }
};
exports.getVehicleKeyForVehicleType = getVehicleKeyForVehicleType;
const getVehicleKeyForConfigurationDetails = (cd) => {
    var _a, _b, _c, _d;
    const fuelType = (_b = (_a = cd["model"]) === null || _a === void 0 ? void 0 : _a.additionalProperties) === null || _b === void 0 ? void 0 : _b["fuel-type"];
    const engineType = (_d = (_c = cd["model"]) === null || _c === void 0 ? void 0 : _c.additionalProperties) === null || _d === void 0 ? void 0 : _d["engine-type"];
    if (engineType === "combustion") {
        if (fuelType === "gasoline" || fuelType === "diesel") {
            return "normal";
        }
        else if (fuelType === "gtron") {
            return "gas";
        }
    }
    if (engineType === "electric") {
        return "electro";
    }
    if (engineType === "hybrid") {
        return "hybrid";
    }
    return "normal";
};
exports.getVehicleKeyForConfigurationDetails = getVehicleKeyForConfigurationDetails;
const getTranslationKeyForVehicleType = (key, vehicleType, options) => {
    const discharged = (options === null || options === void 0 ? void 0 : options.discharged) || false;
    const vehicleKey = (0, exports.getVehicleKeyForVehicleType)(vehicleType);
    return `${key}.${vehicleKey}${discharged ? ".discharged" : ""}`;
};
exports.getTranslationKeyForVehicleType = getTranslationKeyForVehicleType;
// Obtain the vehicletype from the flags 'isPureCNG' and 'isPureElectric'
const getVehicleKeyForCarline = (carline) => {
    const { eecModel } = carline;
    if (eecModel.isHybrid) {
        return "hybrid";
    }
    if (eecModel.isPureCNG) {
        return "gas";
    }
    if (eecModel.isPureElectric) {
        return "electro";
    }
    return "normal";
};
exports.getVehicleKeyForCarline = getVehicleKeyForCarline;
const getTranslationKeyForCarline = (key, carline) => (0, exports.getTranslationKeyForVehicleType)(key, (0, vehicleType_1.getVehicleTypeForCarline)(carline));
exports.getTranslationKeyForCarline = getTranslationKeyForCarline;
